// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1jKG5","footer":"ModalError_footer__3ZTyt"};